import { useErrorAlert } from "@/shared/lib/useErrorAlert";
import companyApi from "../api/company.api";
import { CompanyInterface } from "../model/HeaderDashboardStore.model";
import { useHeaderDashboard } from "./useHeaderDashboard";

export const useHeaderDashboardActions = () => {
  const { setLoading, setError } = useHeaderDashboard();
  const { showErrorAlert } = useErrorAlert()


  const fetchCompanies = async (str: string): Promise<CompanyInterface[] | null> => {
    setLoading("companies", true);
    setError("companies", null);
    try {
      const response = await companyApi.searchByInnOrName(str);
      const unique = response.data.filter(
        (item: CompanyInterface, idx: number, self: CompanyInterface[]) =>
          self.findIndex(i => String(i.inn) === String(item.inn)) === idx
      );
      return unique;
    } catch (error: any) {
      setError("companies", error.message);
      showErrorAlert(error)
      return null
    } finally {
      setLoading("companies", false);
    }
  }

  return {
    fetchCompanies
  }
}